export interface Config {
    [key: string]: Array<{
        url: string;
        title: string;
        internal?: boolean;
    }>;
}

const config: Config = {
    section1: [
        {
            url: '/myaccount',
            title: 'personal_data',
        },
        {
            url: '/myaccount/order',
            title: 'orders_and_returns',
            internal: true,
        },
        {
            url: '/myaccount/coupon',
            title: 'coupons',
        },
    ],
    section2: [
        {
            url: '/myaccount/filter',
            title: 'my_filters',
        },
        {
            url: '/myaccount/newsletter',
            title: 'notifications',
        },
    ],
    section3: [
        {
            url: '/contact',
            title: 'contact_form',
        },
    ],
};

export default config;
